<template>
  <footer class="footer">

    <section class="half-container">

      <div class="half-block social">
        <a href="https://www.instagram.com/beautyscripts/" target="_blank">
          <img src="@/assets/images/icons/instagram-black.svg">
        </a>
        <a href="https://www.facebook.com/beautyscripts/" target="_blank">
          <img src="@/assets/images/icons/facebook-black.svg">
        </a>
        <a href="https://www.pinterest.com/beautyscripts/" target="_blank">
          <img src="@/assets/images/icons/pinterest-black.svg">
        </a>
      </div>

      <div class="half-block mailing">
        <div class="input-container">
          <input v-model="mailingEmailAddress" type="text" name="mailing-list" placeholder="Join our mailing list.">
          <button v-on:click="addToMailingList()" v-bind:disabled="!isEmailValid" type="submit" name="button">
            <LoadingSpinner v-if="isAddingEmail" v-bind:isBlack="true"></LoadingSpinner>
            <span v-else>SUBMIT</span>
          </button>
        </div>
        <span v-if="emailMessage">{{emailMessage}}</span>
      </div>

      <div class="half-block copyright">
        <span class="copy">All Rights Reserved, Beauty Scripts, LLC 2021</span>
      </div>

      <div class="half-block links">
        <router-link :to="{ name: 'LearnMore' }">About</router-link>
        <a href="https://blog.beautyscripts.com/privacy" target="_blank" class="privacy">Privacy</a>
        <TermsLink />
      </div>
    </section>

  </footer>
</template>

<script>

import LoadingSpinner from '@/components/utilities/LoadingSpinner'
import TermsLink from '@/components/utilities/TermsLink'
import formHelper from '@/helpers/formHelper'

export default {
  name: 'Foot',
  components: {
    TermsLink,
    LoadingSpinner
  },
  data () {
    return {
      isAddingEmail:            false,
      mailingEmailAddress:      null,
      emailMessage:             null
    }
  },
  computed: {
    isEmailValid () {
      return formHelper.validateEmail(this.mailingEmailAddress)
    }
  },
  methods: {
    addToMailingList () {
      this.isAddingEmail = true

      this.axios.post('/public/users/add_bx_lover', { email_address: this.mailingEmailAddress })
        .then((response) => {
          this.mailingEmailAddress  = null
          this.isAddingEmail        = false
          this.emailMessage         = 'Thanks! You have successfully been added to our mailing list.'
        })
    }
  }
}
</script>

<style lang="scss">

@import "@/assets/variables/_colors.scss";

.footer {

  background-color:         $bs-primary;
  display:                  flex;
  align-items:              center;
  padding:                  1.5em 0;

  .half-container {
    display:                flex;
    align-items:            center;
    flex-wrap:              wrap;
    padding:                0 2em;
    width:                  100%;

    .half-block {
      width:                50%;
      margin:               1em 0;

      &.description {
        padding-right:      2em;
      }

      &.links {
        margin-bottom:    1em;

        a {
          margin-right:   2em;
        }
      }

      &.social {

        img {
          width:            2em;
          cursor:           pointer;
          margin-right:     0.25em;

          &:hover {
            opacity:        0.5;
          }
        }
      }

      &.mailing {

        .input-container {
          position:         relative;
          min-width:        15em;
          width:            80%;
        }

        input {
          padding:          0.5em 8em 0.5em 0.5em;
          width:            100%;
          background-color: rgb(239, 239, 239);
          border:           1px solid black;
        }

        button {
          position:         absolute;
          right:            0;
          top:              0;
          padding:          0 2em;
          height:           100%;
          border:           1px solid black;
          border-left:      none;
          cursor:           pointer;
          text-transform:   uppercase;
          color:            white;
          background-color: black;

          &:hover {
            opacity:        0.5;
          }
        }
      }
    }

    a {
      cursor:               pointer;
      text-decoration:      none;
      color:                black;

      &:hover {
        opacity:            0.5;
      }
    }
  }
}

/* Portrait tablet to landscape and desktop */
@media (max-width: 768px) {

  .footer {

    .half-container {

      .half-block {
        width:              100%;
        margin:             1em 0;

        &.description {
          padding-right:    0;
        }

        &.mailing {

          .input-container {
            width:          100%;
          }
        }

      }

    }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/Foot.vue